import { PROJECT_CONFIG } from '@/config/projects';

export interface AppLogo {
  width?: number;
  height?: number;
}


const AppLogo = ({ width = 100, height = 'auto', showIcon = false, ...props }: any) => {
  const logoSource = showIcon ? PROJECT_CONFIG.logoIcon ?? PROJECT_CONFIG.logo : PROJECT_CONFIG.logo;
  return (
    <img
      src={logoSource}
      alt={PROJECT_CONFIG.alt}
      loading="lazy"
      width={width}
      height={height}
      style={{ maxWidth: '100%', verticalAlign: 'middle' }}
      {...props}
    />
  );
};

export default AppLogo;
